export const Protocol = {
  OpenId: 1,
  Oauth2: 2,
  Saml: 3,
};
